// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3e5ca0a1","787":"7ec08df1"}[chunkId] + ".chunk.js";
};